export default "__VITE_ASSET__DGS04Dqz__"